import React from "react";
import { Button, ButtonProps } from "@mui/material";
import styles from "./CustomButton.module.scss";
import { SxProps } from "@mui/system";

interface CustomButtonProps extends ButtonProps {
  text: string;
  icon?: React.ReactNode;
  colorScheme?: string;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  text,
  variant,
  icon,
  sx,
  colorScheme = "default",
  ...props
}) => {
  const getVariantClass = () => {
    if (variant === "contained" && colorScheme === "whiteContained") {
      return styles.whiteContained;
    }
    return variant === "contained" ? styles.contained : styles.outlined;
  };

  return (
    <Button
      variant={variant}
      className={`${styles.customButton} ${getVariantClass()}`}
      {...props}
      sx={{
        borderRadius: "24px",
        fontWeight: 600,
        textTransform: "none",
        padding: "10px 2rem",
        display: "flex",
        alignItems: "center",
        ".MuiButton-startIcon": {
          marginRight: "1.5rem",
        },
        ...(sx as SxProps),
      }}
    >
      {icon && (
        <span style={{ marginRight: "8px", marginTop: "5px" }}>{icon}</span>
      )}
      {text}
    </Button>
  );
};

export default CustomButton;
